
import React from 'react'
import Dialog from '@material-ui/core/Dialog';
import { makeStyles } from '@material-ui/core/styles'
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Alert from '@material-ui/lab/Alert';
import {
  STATUS_CHANGE_DIALOG_TITLE,
  STATUS_CHANGE_DIALOG_PREFIX,
  STATUS_CHANGE_DEACTIVATE,
  STATUS_CHANGE_ACTIVATE,
  STATUS_CHANGE_CONFIRM,
  CANCEL_BUTTON_TEXT,
} from './constants'
const useStyles = makeStyles((theme) => ({
  loadingIndicator: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const ToggleStatusModal = ({
  isDialogOpen,
  handleCloseDialog,
  handleConfirmStatusChange,
  loadingUpdateAliasUserStatus,
  updateAliasUserStatusError,
  selectedUser,
}) => {
  const classes = useStyles();
  return (
    <Dialog
    open={isDialogOpen}
    onClose={handleCloseDialog}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
  >
    <DialogTitle>
      {STATUS_CHANGE_DIALOG_TITLE}
    </DialogTitle>
    <DialogContent>
      <DialogContentText>
        {STATUS_CHANGE_DIALOG_PREFIX}{selectedUser?.active ? STATUS_CHANGE_DEACTIVATE : STATUS_CHANGE_ACTIVATE} {selectedUser?.firstName} {selectedUser?.lastName}?
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseDialog} color="primary">
        {CANCEL_BUTTON_TEXT}
      </Button>
       <Button onClick={handleConfirmStatusChange} color="primary" autoFocus disabled={loadingUpdateAliasUserStatus || updateAliasUserStatusError} data-testid="confirm-status-change-button">
          {STATUS_CHANGE_CONFIRM}
        </Button>
    </DialogActions>
    {loadingUpdateAliasUserStatus && (
      <div className={classes.loadingIndicator}>
        <CircularProgress size={24} />
        <span style={{ marginLeft: '8px' }}>Confirming...</span>
      </div>
    )}
    {updateAliasUserStatusError && (
      <Alert severity="error">{updateAliasUserStatusError}</Alert>
    )}
  </Dialog>
  )
}

export default ToggleStatusModal;
